import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBDropDown, DBTextField, DBDateField, CopyButton } from '_components';
import { getDateMMDDYYYY } from '_helpers';
import styles from './Common.module.css';
import { GoalDropDown } from './GoalDropDown';
import { PatientCareCenterNoteNavAnchor } from '../NavAnchor';
import { PatientCareCenterNoteGoalsGoalDetailsFuncDelete } from './DetailsFuncDelete';
import { WCGoalDropDown } from './WCGoalDropDown';

class PatientCareCenterNoteGoalsLTGDetails extends React.Component {

    goalValueChanged() {
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    deleteGoal() {
        this.props.updateBitField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GODELETED', true);
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }


    copyClof() {
        this.props.updateIntField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOCLOF', this.props.goal.GOCLOFPREV);
    }

    copyProgress() {
        this.props.updateIntField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOGPNO', this.props.goal.GOGPNOPREV);
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            prevProps.goal.GOGOALLEVEL &&
            !Object.keys(this.props.goalLevels).map(key => { return this.props.goalLevels[key].id }).includes(prevProps.goal.GOGOALLEVEL)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOGOALLEVEL');
        }
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            prevProps.goal.GOPLOF &&
            !Object.keys(this.props.goalLevels).map(key => { return this.props.goalLevels[key].id }).includes(prevProps.goal.GOPLOF)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOPLOF');
        }
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            prevProps.goal.GOCLOF &&
            !Object.keys(this.props.clofGoalLevels).map(key => { return this.props.clofGoalLevels[key].id }).includes(prevProps.goal.GOCLOF)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOCLOF');
        }
    }

    render() {
        return (
            <PatientCareCenterNoteNavAnchor id={'goal_' + this.props.goal.GONO} >
                <div className={styles.goal_detail_row}>
                    <span className={styles.goal_detail_col1}>
                        {(!this.props.isPrevGoal || this.props.isSpeech) &&
                            <CancelButton title='Delete Goal' size='extra-small' onClick={() => this.deleteGoal()} />
                        }
                    </span>
                    {/* Activity */}
                    <div className={styles.ltg_activity}>
                        {this.props.isCustom &&
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOCUSTOM'
                                disabled={this.props.activityDisabled}
                                className={this.props.activityReq ? styles.ltg_activity_dropdown_req : styles.ltg_activity_dropdown}
                            />

                        }
                        {!this.props.isCustom && !this.props.isWc &&
                            <GoalDropDown
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                isFunctional={this.props.isFunctional}
                                isSpeech={this.props.isSpeech}
                                includeCustom={false}
                                disabled={this.props.activityDisabled}
                                className={this.props.activityReq ? styles.ltg_activity_dropdown_req : styles.ltg_activity_dropdown}
                            />
                        }
                        {!this.props.isCustom && this.props.isWc &&
                            <WCGoalDropDown
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                isWc={true}
                                includeCustom={false}
                                disabled={this.props.activityDisabled}
                                className={this.props.activityReq ? styles.ltg_activity_dropdown_req : styles.ltg_activity_dropdown}
                            />
                        }
                    </div>
                    {/* PLOF */}
                    <div className={styles.ltg_plof_clof_goal}>
                        <DBDropDown
                            className={this.props.plofReq ? styles.ltg_goal_dropdown_req : styles.ltg_goal_dropdown}
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            field='GOPLOF'
                            disabled={this.props.plofDisabled}
                            customOptions={this.props.goalLevels}
                        />
                    </div>
                    {/* CLOF */}
                    <div className={styles.ltg_plof_clof_goal}>
                        <span className={styles.ltg_goal_clof_wrapper}>
                            <span className={styles.ltg_goal_dropdown_clof}>
                                <DBDropDown
                                    className={this.props.clofReq ? styles.ltg_goal_dropdown_req : styles.ltg_goal_dropdown}
                                    noteId={this.props.noteId}
                                    entity='PTGOALS'
                                    entityKeyColumn='GONO'
                                    entityKeyValue={this.props.goal.GONO}
                                    field='GOCLOF'
                                    disabled={this.props.clofDisabled}
                                    customOptions={this.props.clofGoalLevels}
                                    placeholder='Current Ability'
                                />
                            </span>
                            {(this.props.noteType === 3 || this.props.noteType === 5) &&
                                <span className={styles.goal_detail_copy_clof}>
                                    <CopyButton size='extra-small' title='Copy value from most recent note' onClick={() => this.copyClof()} />
                                </span>
                            }
                        </span>
                    </div>

                    {/* GOAL */}
                    <div className={styles.ltg_plof_clof_goal}>
                        {!this.props.hideGoal &&
                            <DBDropDown
                                className={this.props.goalReq ? styles.ltg_goal_dropdown_req : styles.ltg_goal_dropdown}
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOGOALLEVEL'
                                disabled={this.props.goalDisabled}
                                customOptions={this.props.goalLevels}
                            />
                        }
                    </div>
                    {/* DATE */}
                    <div className={styles.stg_date}>
                        <span className={styles.date_field}>
                            <DBDateField
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GODATE'
                                disabled={this.props.dateDisabled}
                                customMsg='The goal date cannot be in the past.'
                                minDate={getDateMMDDYYYY(new Date())}
                                required={this.props.dateReq}
                            />
                        </span>
                    </div>


                    {/* PROGRESS */}
                    {this.props.noteType !== 1 &&
                        <>
                            <span className={styles.goal_detail_prog_dropdown_stg}>
                                <DBDropDown
                                    className={this.props.progReq ? styles.ltg_goal_prog_dropdown_req : styles.ltg_goal_prog_dropdown}
                                    noteId={this.props.noteId}
                                    entity='PTGOALS'
                                    entityKeyColumn='GONO'
                                    entityKeyValue={this.props.goal.GONO}
                                    field='GOGPNO'
                                    masterEntity='PTMASTERGOALPROGRESS'
                                    masterEntityKeyColumn='GPNO'
                                    masterEntitySort='GPORDER'
                                    masterEntityDisplay='GPNAME'
                                    disabled={this.props.progDisabled}
                                    onChange={() => this.goalValueChanged()}
                                />
                            </span>
                            {(this.props.noteType === 3 || this.props.noteType === 5) &&
                                <div className={styles.goal_detail_copy_col}>
                                    <CopyButton size='extra-small' title='Copy value from most recent note' onClick={() => this.copyProgress()} />
                                </div>
                            }
                        </>
                    }

                </div>
                <div className={styles.goal_detail_row}>
                    <div className={styles.goal_detail_col8_pd}>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            field='GOOBJECTIVE'
                            className={this.props.descReq ? styles.text_field_req : styles.text_field}
                            disabled={this.props.goalMet}
                            placeholder='Describe how the patient is performing the activity today.'
                        />
                    </div>
                </div>
            </PatientCareCenterNoteNavAnchor>

        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let goalsUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTGOALSUPDATED : true;
    let goalPreviouslyMet = false;
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isFunctional = true;

    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isSpeech = state.entities.admissions[epno].discipline === "ST" ? true : false;
    if (!isSpeechEnabled) {
        isSpeech = isSpeechEnabled;
    }


    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
    if (!isPedsEnabled) {
        isPeds = isPedsEnabled;
    }

    if (state.entities.notes.PTGOALS[ownprops.id].GOGPNOPREV === 11) {
        goalPreviouslyMet = true;
    }

    if (isPeds || isSpeech) {
        isFunctional = false;
    }

    let clofGoalLevels = [];
    if (goal.GOMGNO) {
        // get based on XREF
        let glnos = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
            .filter(key => {
                return (state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO);
            })
            .map(key => state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO);

        clofGoalLevels = Object.keys(state.entities.masterData.PTMASTERGOALLEVELS)
            .filter(key => {
                return (glnos.includes(state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO));
            })
            .sort((a, b) => {
                let aKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                    .find(key => {
                        return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                            state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[a].GLNO
                    });
                let aOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[aKey].GLXORDER;

                let bKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                    .find(key => {
                        return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                            state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[b].GLNO
                    });
                let bOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[bKey].GLXORDER;

                return aOrder - bOrder;
            })
            .map(key => {
                return {
                    id: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO,
                    value: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNAME,
                    sentence: state.entities.masterData.PTMASTERGOALLEVELS[key].GLSENTENCETXT,
                    clofOnly: state.entities.masterData.PTMASTERGOALLEVELS[key].GLCLOFONLY,
                }
            })
    }

    let goalLevels = Object.keys(clofGoalLevels)
        .filter(key => {
            if (isPeds) {
                return clofGoalLevels[key];
            }
            else {
                return clofGoalLevels[key].clofOnly === false;
            }
        })
        .map(key => {
            return clofGoalLevels[key];
        });



    let isWc = state.entities.admissions[epno].isWc;

    let isCustom = (goal.GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID'].PRVALUE) && !isWc) ||
        (goal.GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID_WC'].PRVALUE) && isWc) ? true : false;

    let pdcDisabled = false;

    if (noteType === 1 && !state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC && isWc) {
        pdcDisabled = true;
    }


    let activityReq = !goal.GOMGNO || (isCustom && !goal.GOCUSTOM) ? true : false;
    let plofReq = noteType !== 2 && !goal.GOPLOF ? true : false;
    let clofReq = noteType !== 2 && !goal.GOCLOF ? true : false;
    let goalReq = noteType !== 2 && !goal.GOGOALLEVEL ? true : false;
    let dateReq = noteType !== 2 && !goal.GODATE ? true : false;
    let progReq = !goal.GOGPNO ? true : false;
    let descReq = (noteType === 1 || noteType === 3 || noteType === 5) && !goal.GOOBJECTIVE ? true : false;

    let progDisabled = goalPreviouslyMet || pdcDisabled ? true : false;
    let activityDisabled = goal.GOGONO || goalPreviouslyMet || pdcDisabled ? true : false;
    let plofDisabled = noteType === 2 || noteType === 4 || noteType === 6 || goalPreviouslyMet || pdcDisabled ? true : false;
    let clofDisabled = (noteType === 2 && goal.GOGPNO !== null && goal.GOGPNO === 11) || goalPreviouslyMet || pdcDisabled ? true : false;
    let goalDisabled = noteType === 2 || noteType === 4 || noteType === 6 || goalPreviouslyMet || pdcDisabled ? true : false;
    let dateDisabled = noteType === 2 || noteType === 4 || noteType === 6 || goalPreviouslyMet || pdcDisabled ? true : false;
    
    let masterLifts = [158, 159, 160, 161, 162, 163, 164, 165, 166];
    let masterPushes = [170, 171, 172, 173, 174, 175, 176, 177, 178];

    let hideGoal = masterLifts.includes(goal.GOMGNO) || masterPushes.includes(goal.GOMGNO) ? true : false;



    return {
        noteId,
        noteType,
        pk,
        goal,
        clofGoalLevels,
        goalLevels,
        goalsUpdated,
        isPrevGoal: goal.GOGONO ? true : false,
        activityReq,
        plofReq,
        clofReq,
        goalReq,
        dateReq,
        progReq,
        activityDisabled,
        plofDisabled,
        clofDisabled,
        goalDisabled,
        dateDisabled,
        progDisabled,
        isCustom,
        isWc,
        hideGoal,
        descReq,
        isSpeech,
        isFunctional
    };
}

const connectedPatientCareCenterNoteGoalsLTGDetails = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsLTGDetails);
export { connectedPatientCareCenterNoteGoalsLTGDetails as PatientCareCenterNoteGoalsLTGDetails };

